export default {
  buildRuleOptions (rules) {
    const self = this
    const options = []
    rules.forEach(rule => {
      options.push({ text: self.ruleText(rule), value: rule })
    })

    return options
  },
  ruleText (rule) {
    const map = {
      required: 'Wymagane',
      email: 'E-mail',
      phone: 'Nr telefonu',
      'url:https,http': 'URL',
      postCodePL: 'Kod pocztowy (PL)',
      nip: 'NIP',
      custom: 'Custom'
    }

    return map[rule] || 'Custom - ' + rule
  },
  inputTypeText (type) {
    const map = {
      text: 'Pole tekstowe',
      textarea: 'Pytanie otwarte',
      select: 'Rozwijana lista',
      checkbox: 'Checkbox',
      date: 'Wybór daty'
    }

    return map[type] || type
  }
}
